/**
 * Air inside a hollow. Gravity points outward, so the air is densest against the
 * wall and thins toward the centre: densities are exp(−altitude / scaleHeight)
 * where altitude is measured from the wall inward.
 */
export interface AtmosphereDef {
  /** Rayleigh scattering coefficients at the wall, 1/m (RGB). */
  rayleigh: [number, number, number];
  rayleighHeight: number;
  /** Mie (haze) scattering at the wall, 1/m. */
  mie: number;
  mieHeight: number;
  /** Mie absorption as a fraction of Mie scattering. */
  mieAbsorption: number;
  /** Mie phase anisotropy (0..0.95). */
  mieG: number;
  /** Scales the integrating-sphere ambient light scattered by the air. */
  ambientScatter: number;
  /**
   * Multiplies all the light the air scatters (default 1). The air is lit by single
   * scattering only, which leaves it dark next to sunlit ground: this keeps the far side of
   * a sunlit hollow reading as sky.
   */
  scatterBoost?: number;
  /**
   * Light emitted by the air itself (glowing spores, embers), radiance per metre
   * at the wall. It follows the haze density and the light rig's glow phase.
   */
  airGlow?: [number, number, number];
}

export const VERDANT_AIR: AtmosphereDef = {
  rayleigh: [5.8e-6 * 1.4, 13.5e-6 * 1.4, 33.1e-6 * 1.4],
  rayleighHeight: 3500,
  mie: 4e-6,
  mieHeight: 900,
  mieAbsorption: 0.1,
  mieG: 0.78,
  ambientScatter: 0.6,
  // (3 before the palettes moved toward real albedos: with the ground darker and the exposure
  // up, it washed the far side out; the land should read through the air, not under it.)
  scatterBoost: 1.7,
};
